import { render, staticRenderFns } from "./top-tips-pop.vue?vue&type=template&id=57412426&scoped=true&"
import script from "./top-tips-pop.vue?vue&type=script&lang=js&"
export * from "./top-tips-pop.vue?vue&type=script&lang=js&"
import style0 from "./top-tips-pop.vue?vue&type=style&index=0&id=57412426&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57412426",
  null
  
)

export default component.exports